<div id="dashboard-analytics" class="page-layout blank">
    <div class="content">

        <div class="left mr-lg-32">
            <div class="pb-24 font-size-18 font-weight-300">
                <button (click)="today()" mat-raised-button class="mr-8" color="accent">{{'Today'|translate}}</button>
                <button (click)="yesterday()" mat-raised-button class="mr-8" color="accent">{{'Yesterday'|translate}}</button>
                <button (click)="lastWeek()" mat-raised-button class="mr-8" color="accent">{{'Last week'|translate}}</button>
                <button (click)="lastMonth()" mat-raised-button class="mr-8" color="accent">{{'Last month'|translate}}</button>
            </div>

            <div fxLayout="column" fxLayoutAlign="start"
                 fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
                <!-- Date Range Widget -->
                <div class="widget" fxFlex="100" fxFlex.gt-sm="50">
                    <div class="fuse-card auto-width mb-32" [ngClass.gt-sm]="'mb-0 mr-32'">
                        <div class="p-16 pb-0" fxLayout="row wrap" fxLayoutAlign="start end">
                            <div class="pr-16">
                                <div class="h3 secondary-text">{{'Date range'|translate}}</div>
                                <div class="font-size-40 font-weight-300 line-height-1 mt-8">
                                    <form [formGroup]="dateRange">
                                        <mat-form-field appearance="fill">
                                            <mat-label>Start date</mat-label>
                                            <input matInput formControlName="start" [matDatepicker]="picker"
                                                   (dateChange)="reloadStats($event)">
                                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker></mat-datepicker>
                                        </mat-form-field>
                                        <mat-form-field appearance="fill">
                                            <mat-label>End date</mat-label>
                                            <input matInput formControlName="end" [matDatepicker]="picker2"
                                                   (dateChange)="reloadStats($event)">
                                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                            <mat-datepicker #picker2></mat-datepicker>
                                        </mat-form-field>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Training Type Filter Widget -->
                <div class="widget" fxFlex="100" fxFlex.gt-sm="50">
                    <div class="fuse-card auto-width mb-32" [ngClass.gt-sm]="'mb-0'">
                        <div class="p-16 pb-0" fxLayout="row wrap" fxLayoutAlign="start end">
                            <div class="pr-16" style="width: 100%;">
                                <div class="h3 secondary-text">{{'Training type'|translate}}</div>
                                <div class="font-size-40 font-weight-300 line-height-1 mt-8">
                                    <mat-form-field appearance="fill" style="width: 100%;">
                                        <mat-label>{{'Select training type'|translate}}</mat-label>
                                        <mat-select [(value)]="selectedType" (selectionChange)="onTypeChange()">
                                            <mat-option *ngFor="let type of trainingTypes" [value]="type.value">
                                                {{type.label|translate}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div fxLayout="column" fxLayoutAlign="start"
                 fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start" style="padding-bottom: 10px;">
                <div class="widget pt-0" fxFlex="100">
                    <div class="fuse-card content-card auto-width">
                        <div class="p-16" fxLayout="row" fxLayoutAlign="space-between center">
                            <div class="h1 pr-16">
                                {{ 'Training Commission Report'|translate }}
                            </div>
                        </div>
                        <table class="simple clickable">
                            <thead>
                            <tr>
                                <th>{{'Training Type'|translate}}</th>
                                <th>{{'Service'|translate}} / {{'Vouchers'|translate}}</th>
                                <th>{{'Worker'|translate}}</th>
                                <th>{{'Customer'|translate}}</th>
                                <th>{{'Date'|translate}}</th>
                                <th class="text-right">{{'Commission Value'|translate}}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let row of reportData">
                                <td>{{row.type|translate}}</td>
                                <td>{{row.service?.name || row.voucherTemplate?.name || '-'}}</td>
                                <td>{{row.worker?.firstName}} {{row.worker?.lastName}}</td>
                                <td>{{row.customer?.firstName}} {{row.customer?.lastName}}</td>
                                <td>{{row.createdAt|date: 'dd.MM.y HH:mm:ss': 'UTC+1': 'pl'}}</td>
                                <td class="text-right">{{row.commissionValue | number:'1.2-2'}} PLN</td>
                            </tr>
                            <tr *ngIf="reportData && reportData.length > 0">
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="text-right" style="font-weight: bold;">{{'Total'|translate}}</td>
                                <td class="text-right" style="font-weight: bold;">{{summary | number:'1.2-2'}} PLN</td>
                            </tr>
                            <tr *ngIf="!reportData || reportData.length === 0">
                                <td colspan="6" class="text-center" style="padding: 20px;">
                                    {{'No data available for selected period and type'|translate}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>


        </div>
    </div>
</div>